import { render, staticRenderFns } from "./PriceTableEKG.vue?vue&type=template&id=53656c22&"
import script from "./PriceTableEKG.vue?vue&type=script&lang=js&"
export * from "./PriceTableEKG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports